function trackElementScrollPercentage(secector) {
  const element = document.querySelector(secector);
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const elementHeight = rect.height;
  const elementTop = rect.top;

  const windowHeight = window.innerHeight;
  const scrollY = window.scrollY;

  const totalPageHeight = document.documentElement.scrollHeight;

  const elementTopRelativeToPage = rect.top + scrollY;

  const scrollProgress = (scrollY / (totalPageHeight - windowHeight)) * 100;

  const elementVisibleTop = Math.max(0, -elementTopRelativeToPage);
  const elementVisibleBottom = Math.max(0, Math.min(elementHeight, windowHeight - elementTop));

  const visibleHeight = elementVisibleTop + elementVisibleBottom;

  const visiblePercentage = Math.min((visibleHeight / elementHeight) * 100, 100);

  return visiblePercentage.toFixed(2);
}

function stickyServces() {
  const ctaSticky = document.querySelector("[data-cta-sticky]");

  if (!ctaSticky) return;

  function updateScrollProgress(procent) {
    const progress = document.querySelector(".sticky-scroll__progress");
    if (!progress) return;
    progress.style.width = `${procent}%`;
  }

  function formatTwoSignNumber(number) {
    return Number(number) < 10 ? `0${number}` : String(number);
  }

  function resetHeading(heading) {
    const headingElement = document.querySelector(`[data-sticky-heading='${heading}']`);
    headingElement.querySelectorAll("span").forEach((span) => [span.classList.remove("active")]);
  }

  function showHeading(heading) {
    document.querySelectorAll("[data-sticky-heading]").forEach((element) => {
      element.style.display = "none";
    });

    document.querySelector(`[data-sticky-heading='${heading}']`).style.display = "inline-block";
  }

  function activeWordInHeading(heading, word) {
    const headingElement = document.querySelector(`[data-sticky-heading='${heading}']`);
    headingElement.querySelector(`span:nth-of-type(${word})`).classList.add("active");
  }

  function offHeadingEffect(heading, offset, procent) {
    const headingElement = document.querySelector(`[data-sticky-heading='${heading}']`);

    const procentFragmet = (procent - offset) * 10;
    const scale = `${procentFragmet / 350 + 1}`;
    const blur = `${procentFragmet / 16}`;
    const opacity = `0.${formatTwoSignNumber(Math.abs(Math.ceil(procentFragmet) - 100))}`;

    headingElement.style.transform = `scale(${scale}) `;
    headingElement.style.filter = `blur(${blur}px)`;
    headingElement.style.opacity = opacity;
  }

  function resetEffectOff(heading) {
    const headingElement = document.querySelector(`[data-sticky-heading='${heading}']`);

    headingElement.style.transform = `scale(1) `;
    headingElement.style.filter = `blur(0)`;
    headingElement.style.opacity = 1;
  }

  window.addEventListener("scroll", () => {
    const procent = trackElementScrollPercentage("[data-cta-sticky]");
    updateScrollProgress(procent);

    switch (true) {
      case procent >= 0 && procent < 45:
        showHeading(1);
        resetHeading(2);
        if (procent >= 10 && procent < 15) activeWordInHeading(1, 1);
        if (procent >= 15 && procent < 19) activeWordInHeading(1, 2);
        if (procent >= 19 && procent < 23) activeWordInHeading(1, 3);
        if (procent >= 23 && procent < 27) activeWordInHeading(1, 4);
        if (procent >= 27 && procent < 31) activeWordInHeading(1, 5);
        if (procent >= 31 && procent < 35) {
          activeWordInHeading(1, 6);
          resetEffectOff(1);
        }
        if (procent >= 35 && procent < 45) offHeadingEffect(1, 35, procent);
        break;

      case procent >= 45 && procent < 69:
        showHeading(2);
        resetHeading(1);
        resetHeading(3);
        if (procent >= 47 && procent < 51) activeWordInHeading(2, 1);
        if (procent >= 51 && procent < 55) {
          activeWordInHeading(2, 2);
          resetEffectOff(2);
        }
        if (procent >= 59 && procent < 69) offHeadingEffect(2, 59, procent);
        break;

      case procent >= 69 && procent < 93:
        showHeading(3);
        resetHeading(2);
        if (procent >= 71 && procent < 75) activeWordInHeading(3, 1);
        if (procent >= 75 && procent < 79) activeWordInHeading(3, 2);
        if (procent >= 79 && procent < 83) {
          activeWordInHeading(3, 3);
          resetEffectOff(3);
        }
        if (procent >= 83 && procent < 93) offHeadingEffect(3, 83, procent);
        break;
      case procent >= 100:
        resetHeading(3);
        break;

      default:
        break;
    }
  });
}

stickyServces();
